module.exports = __webpack_public_path__ + "media/images/category/dummy/hat02-158fafddbcbfb44d834c5124507bd71b.jpg";